export const EditorNotSupportedNotificationDataHooks = {
  container: 'editor-not-supported-notification-container',
  description: 'editor-not-supported-notification-description',
};
